<template>
    <div class="form-group text-form-group focus-form-group clearfix" :class="[colClass, customErrorClass]">
        <p class="pdf-inline">
            <strong class="display-label">{{ effectiveLabelText }}:</strong>
            <span class="display-value">{{ extraShimValue }}</span>
        </p>
        <Comments :data="data" />
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useObservable } from "@vueuse/rxjs";
import { map } from "rxjs/operators";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import ExtraDataShimDef from "../elements/ExtraDataShimDef";
import { ExtraDataShimSettings } from "@cs-ts/extra-data-shim-settings";
export default defineComponent({
    components: {
        ...components,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<ExtraDataShimDef, ExtraDataShimSettings>) {
        const base = setup<ExtraDataShimDef, ExtraDataShimSettings>(props);
        const extraShimValue = useObservable(props.data.extraShimValue$().pipe(map(i => (i.length ? i[0] : null))));
        const effectiveLabelText = useObservable(props.data.effectiveLabelText$());

        return {
            extraShimValue,
            effectiveLabelText,

            ...base.expose,
        };
    },
});
</script>
